var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningHatOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.553 2.106a1 1 0 01.894 0l10 5a1 1 0 010 1.788L20 10.118V18c0 .752-.36 1.386-.838 1.87-.474.48-1.11.867-1.818 1.17-1.419.608-3.309.96-5.344.96s-3.925-.352-5.344-.96c-.707-.303-1.344-.69-1.818-1.17C4.36 19.385 4 18.752 4 18v-7.882L1.553 8.894a1 1 0 010-1.788l10-5zM5.465 8.615a.985.985 0 00-.037-.02L4.236 8 12 4.118 19.764 8l-1.192.596a1.08 1.08 0 00-.037.019L12 11.882 5.465 8.615zM6 11.118V18c0 .076.032.232.262.465.234.238.623.497 1.182.737C8.56 19.68 10.17 20 12 20c1.83 0 3.44-.32 4.556-.798.56-.24.948-.5 1.182-.737.23-.233.262-.389.262-.465v-6.882l-5.553 2.776a1 1 0 01-.894 0L6 11.118z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1z"
  })));
}
export default SvgLearningHatOutline;